export const appConfig = {
  localStorage: {
    authTokenStorageName: 'authToken',
    userRoleStorageName: 'userRole',
    userEmailStorageName: 'userEmail',
    userProfileIdStorageName: 'userProfileId'
  }
}